import { createSlice } from "@reduxjs/toolkit";

const createWorkItems = () => ({
  // "3GQJ-2209-0001.001": {
  //   procedure: {
  //     status: {
  //       procedure: {
  //         num_steps: 1,
  //         num_completed: 0,
  //       },
  //       sections: [
  //         {
  //           section: "2",
  //           num_steps: 1,
  //           num_completed: 0,
  //         },
  //       ],
  //       groups: [
  //         {
  //           section: "2",
  //           group: "1",
  //           num_steps: 1,
  //           num_completed: 0,
  //         },
  //       ],
  //       steps: [
  //         {
  //           step: "2.1",
  //           status: "NOT_STARTED",
  //         },
  //       ],
  //     },
  //   },
  // },
});

const initialState = createWorkItems();

export const workItemsSlice = createSlice({
  name: "workItems",
  initialState,
  reducers: {
    reset: () => initialState,
    setWorkItem: (state, action) => {
      state[action.payload.id] = action.payload;
    },
    setMode: (state, action) => {
      state[action.payload.workItemId] = {
        ...state[action.payload.workItemId],
        mode: action.payload.mode,
      };
    },
    setStarted: (state, action) => {
      state[action.payload.workItemId] = {
        ...state[action.payload.workItemId],
        overrideStatus: true,
      };
    },
    setActionButtonState: (state, action) => {
      state[action.payload.workItemId] = {
        ...state[action.payload.workItemId],
        actionButtonState: action.payload.actionButtonState,
      };
    },
    setProcedureStatus: (state, action) => {
      state[action.payload.workItemId] = {
        ...state[action.payload.workItemId],
        procedure: {
          ...state[action.payload.workItemId]?.procedure,
          status: action.payload.status,
        },
      };
    },
    setWorkItemStatus: (state, action) => {
      state[action.payload.workItemId] = {
        ...state[action.payload.workItemId],
        status: action.payload.status,
      };
    },
    updateWorkItemPerformingUser: (state, action) => {
      state[action.payload.workItemId] = {
        ...state[action.payload.workItemId],
        performing_user: action.payload.performing_user,
        notes: action.payload.notes,
      };
    },
  },
});
